import b_ from 'b_';
import { MesLogo } from 'education-icons';
import { Help, Text, Tooltip, type Popup, type Checkbox } from 'platform-components/common';
import { HELP_ACTION, HELP_TYPE, POPUP_DIRECTIONS, POPUP_THEMES } from 'platform-components/constants';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { getIsLessonEvaluable } from 'utils/lesson';

import * as selectors from '../selectors';
import './assignment__external-lms-notice.scss';

const b = b_.with('assignment');

const helpProps = {
    mix: b('external-lms-notice-info-help'),
    popupProps: {
        theme: POPUP_THEMES.SCHOOL,
        direction: POPUP_DIRECTIONS.BOTTOM,
        hasArrow: true,
        inLayer: true,
    },
    showPopupOnAction: HELP_ACTION.HOVER,
    tooltipMix: b('external-lms-notice-info-tooltip'),
    type: HELP_TYPE.INFO,
};

/**
 * Показывает плашку о том, что занятие выдается в МЭШ
 */
export const ExternalLmsNotice = () => {
    const isEvaluable = useSelector((state) => getIsLessonEvaluable(selectors.getLessonMode(state)));

    const tooltipRef = useRef<Popup>(null);
    const checkboxRef = useRef<Checkbox>(null);

    useEffect(() => {
        if (checkboxRef.current && tooltipRef.current) {
            tooltipRef.current.setOwner(checkboxRef.current.refs.checkboxInput);
        }
    });

    return (
        <div className={b('external-lms-notice')}>
            <div className={b('external-lms-notice-icon-wrapper')}>
                <MesLogo className={b('external-lms-notice-icon')} />
            </div>
            <div>
                <Text id="assignLessonModal.externalLms.notice" values={{ lms: 'mes' }} />
                <Help {...helpProps}>
                    <Text
                        id="assignLessonModal.externalLms.notice.info"
                        type={Text.TYPE.MARKDOWN}
                        values={{ lms: 'mes' }}
                    />
                </Help>
            </div>

            {isEvaluable && (
                <Tooltip
                    mix={b('external-lms-notice-control-tooltip')}
                    onPopupRef={tooltipRef}
                    popupProps={{
                        theme: POPUP_THEMES.SCHOOL,
                        direction: POPUP_DIRECTIONS.RIGHT,
                        hasArrow: true,
                        inLayer: true,
                    }}
                >
                    <Text id="assignment.externaLms.notAvailableBecauseEvaluation.mes" />
                </Tooltip>
            )}
        </div>
    );
};
